<template>
  <div class="text-box">
    <div :class="{ 'over-hidden': !isFold }" ref="textBox">
      <span class="text-content" :style="{ fontSize: contentFontSize }" ref="spanBox">{{ content }}</span>
    </div>
    <div :class="btn" v-if="showBtn" @click="isFold = !isFold">{{ isFold ? '收起' : '展开' }}</div>
  </div>
</template>
<script>
export default {
  name: 'ellipsis',
  data() {
    return {
      showBtn: false,
      isFold: false
    }
  },
  props: {
    content: {
      type: String,
      default: ''
    },
    contentFontSize: {
      type: [String, null],
      default: null
    }
  },
  computed: {
    btn() {
      return this.isFold ? 'btn-up' : 'btn-down'
    }
  },
  mounted() {
    // 判断是否显示展开收起按钮
    this.showBtn = this.$refs.spanBox.offsetHeight > this.$refs.textBox.offsetHeight
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
